import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, TextField, MenuItem, Badge, Select, FormControl, InputLabel } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Box from "@mui/system/Box";
import { makeStyles } from "@mui/styles";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import DeleteIcon from "@mui/icons-material/Delete";
import ChatIcon from "@mui/icons-material/Chat";
import SendIcon from "@mui/icons-material/Send";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { DialogActions } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./Tickets.css";
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(() => ({
  chatMessageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginBottom: "10px",
  },
  chatMessage: {
    backgroundColor: "#007bff",
    color: "white",
    padding: "10px 15px",
    borderRadius: "20px",
    maxWidth: "80%",
    wordWrap: "break-word",
    alignSelf: "flex-start", // Changed to 'flex-start'
  },
  senderChatMessage: {
    backgroundColor: "#ffffff",
    color: "black",
    padding: "10px 15px",
    borderRadius: "20px",
    maxWidth: "80%",
    wordWrap: "break-word",
    alignSelf: "flex-end", // Changed to 'flex-end'
  },
  senderChatMessageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginBottom: "10px",
  },
  receiverChatMessageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginBottom: "10px",
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

function Tickets() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const user_id = parseInt(localStorage.getItem("user_id"), 10);
  const role = localStorage.getItem("role");
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const auth = localStorage.getItem("authToken");
  const { enqueueSnackbar } = useSnackbar();
  const [chatData, setChatData] = useState([]);
  const [openChat, setOpenChat] = useState(false);
  const [chatMessage, setChatMessage] = useState("");
  const [chatMessages, setChatMessages] = useState([]);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [ticketStatus, setTicketStatus] = useState("Open");
  const isSuperAdmin = role === "superadmin";
  const isSubAdmin = role === "sub-admin";

  // GET ALL TICKETS
  const fetchAllTickets = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/ticket/getallticket`,
        { user_id }, 
        {
          headers: {
            Authorization: `Bearer ${auth}`,
          },
        }
      );

      if (response.data.success) {
        setTickets(response.data.ticket);
      }
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (location.pathname === "/tickets") {
      fetchAllTickets();
    }
  }, [location.pathname, user_id]);

  // TICKET DELETE REQUEST
  const handleDelete = (ticketId) => {
    setOpenDetailsDialog(false);
    setShowConfirmationDialog(true);
  };
  
  const onDeleteClick = async (ticketId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/ticket/delete`,
        { ticket_id: ticketId },
        {
          headers: {
            Authorization: `Bearer ${auth}`,
          },
        }
      );
  
      if (response.data.success) {
        setTickets((prevTickets) => prevTickets.filter((ticket) => ticket.ticket_id !== ticketId));
        enqueueSnackbar("Ticket Deleted Successfully !!!", { variant: "success" });
      } else {
        enqueueSnackbar("Error Deleting Ticket !!!", { variant: "error" });
      }
  

      setShowConfirmationDialog(false);
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Error Deleting Ticket !!!", { variant: "error" });
      

      setShowConfirmationDialog(false);
    }
  };
  
  const handleForward = async (ticketId, status, is_admin, user_id) => {
    const isForwarded = true;
    is_admin = isForwarded ? 1 : 0;
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/ticket/update`,
        {
          ticket_id: ticketId,
          status: selectedTicket.status,
          is_admin: is_admin,
          user_id: selectedTicket.user_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth}`,
          },
        }
      );
  
      if (response.data.success) {
        // Handle success response here (if needed)
        const message = isForwarded
          ? "Forwarded to Superadmin Successfully !!!"
          : "Ticket update reverted Successfully !!!";
        enqueueSnackbar(message, { variant: "success" });
        fetchAllTickets();
      } else {
        enqueueSnackbar("Error Forwarding Ticket !!!", { variant: "error" });
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Error Forwarding Ticket !!!", { variant: "error" });
    }
    fetchAllTickets();
  };  
  
  // MESSAGE SENDING LOGIC AND FUNCTIONs
  const handleSendMessage = async () => {
    const message = chatMessage.trim();
  
    if (message !== "" && dialogData) {
      const { ticket_id } = dialogData;
  
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASEURL}/admin/ticket/addchat`,
          {
            ticket_id: ticket_id,
            chat: message,
            user_id: user_id,
          },
          {
            headers: {
              Authorization: `Bearer ${auth}`,
            },
          }
        );
  
        if (response.data.success) {
          await fetchUpdatedChatData(ticket_id); // Fetch the updated chat data
          setChatMessage("");
          enqueueSnackbar("Message Sent Successfully !!!", { variant: "success" });
        } else {
          enqueueSnackbar("Error Sending Message !!!", { variant: "error" });
        }
      } catch (err) {
        console.log(err);
        enqueueSnackbar("Error Sending Message !!!", { variant: "error" });
      }
    }
  };

  const handleStatusChange = async (event) => {
    const newStatus = event.target.value;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/ticket/update`,
        {
          ticket_id: selectedTicket.ticket_id,
          status: newStatus,
          is_admin: selectedTicket.is_admin,
          user_id: selectedTicket.user_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth}`,
          },
        }
      );
  
      if (response.data.success) {
        // Update the ticket status locally
        setTicketStatus(newStatus);
        enqueueSnackbar(`Ticket status changed to ${getStatusLabel(newStatus)} !!!`, {
          variant: "success",
        });
      } else {
        enqueueSnackbar("Error updating ticket status !!!", { variant: "error" });
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Error updating ticket status !!!", { variant: "error" });
    }
    fetchAllTickets();
  };
  
  // Helper function to get the label for each ticket status value
  const getStatusLabel = (statusValue) => {
    switch (statusValue) {
      case 0:
        return "Open";
      case 1:
        return "In Progress";
      case 2:
        return "Closed";
      default:
        return "Unknown";
    }
  };

  const statusOptions = [
    { value: 0, label: "Open" },
    { value: 1, label: "In Progress" },
    { value: 2, label: "Closed" },
  ];

  //Expand button fucntions
  const onDetailsClick = (ticket) => {
    setSelectedTicket(ticket);
    setTicketStatus(ticket.status); 
    setOpenDetailsDialog(true);
  };

// Function to fetch updated chat data
const fetchUpdatedChatData = async (ticketId) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASEURL}/admin/ticket/getallticket`,
      { user_id },
      {
        headers: {
          Authorization: `Bearer ${auth}`,
        },
      }
    );

    if (response.data.success) {
      const updatedTicket = response.data.ticket.find(
        (ticket) => ticket.ticket_id === ticketId
      );
      if (updatedTicket) {
        const updatedChatData = updatedTicket.chat || [];
        setChatData(updatedChatData);

        if (isChatOpen) {
          setChatMessages(updatedChatData);
        }
      }
    }
  } catch (error) {
    console.error(error);
  }
};

// Function to handle opening the chat dialog
const onChatClick = async (rowData) => {
  const chatData = rowData.chat || [];
  setOpenDialog(true);
  setDialogData(rowData); // Update to rowData instead of rowData.row
  setChatData(chatData);

  // Fetch the updated chat data
  await fetchUpdatedChatData(rowData.ticket_id);
};

//Function to open the chat dialog on expanded functions
const onExpandedChatClick = async (rowData) => {
  const chatData = rowData.chat || [];
  setOpenDialog(false); 
  setOpenChat(true);
  setDialogData(rowData); 
  setChatData(chatData);

  // Fetch the updated chat data
  await fetchUpdatedChatData(rowData.ticket_id);
  setOpenDialog(true);
};

return (
  <DashboardLayout>
    <DashboardNavbar hidebreadcrumbTitle />
    <MDBox pt={3} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <MDTypography variant="h6" color="white">
                  Tickets
                </MDTypography>
               { !isSuperAdmin && (
                 <MDBox className="ticket_btnsHeaderCont">
                  <MDButton onClick={() => navigate("/tickets/create")} variant="outlined" color="white">
                    Create Ticket
                  </MDButton>
                </MDBox>
                )}
              </Grid>
            </MDBox>
            <MDBox pt={3}>
              <DataTable
                table={{
                  columns: [
                    { Header: "Ticket ID", accessor: "ticket_id" },
                    { Header: "Title", accessor: "issue_title" },
                    { Header: "User ID", accessor: "user_id" },
                    {
                      Header: "Status",
                      accessor: "status",
                      style: { textAlign: "center" },
                      Cell: ({ row }) => (
                        <>
                          {row.original.status === 0 && (
                            <MDBadge badgeContent="Open" color="success" size="lg" />
                          )}
                          {row.original.status === 1 && (
                            <MDBadge badgeContent="In Progress" color="warning" size="lg" />
                          )}
                          {row.original.status === 2 && (
                            <MDBadge badgeContent="Closed" color="error" size="lg" />
                          )}
                        </>
                      ),
                    },                    
                    {
                      Header: "Action",
                      accessor: "action",
                      Cell: ({ row }) => (
                        <div>
                          <MDButton
                            onClick={() => onChatClick(row.original)}
                            variant="gradient"
                            color="info"
                            style={{
                              minWidth: "unset",
                              padding: "2px 12px",
                              marginBottom: "8px",
                              marginRight: "8px",
                            }}
                          >
                            <ChatIcon />
                          </MDButton>
                          <MDButton
                            onClick={() => onDetailsClick(row.original)}
                            variant="gradient"
                            color="info"
                            style={{
                              minWidth: "unset",
                              padding: "2px 12px",
                              marginBottom: "8px",
                              marginRight: "8px",
                            }}
                          >
                            <KeyboardArrowRightIcon />
                          </MDButton>
                        </div>
                      ),
                    },
                  ],
                  rows: tickets,
                }}
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={false}
                noEndBorder
              />
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
          <Dialog
            fullWidth
            maxWidth="md"
            open={openDetailsDialog}
            onClose={() => setOpenDetailsDialog(false)}
            PaperProps={{
              style: {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              },
            }}
          >
              <DialogTitle>
                <Typography variant="h6" component="span">
                  Ticket Details
                </Typography>
                <IconButton
                  aria-label="close"
                  onClick={() => setOpenDetailsDialog(false)}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                {selectedTicket && (
                  <><MDBox>
                    <Typography variant="overline" display="block">Ticket id: {selectedTicket.ticket_id}</Typography>
                    <Typography variant="button">Title:</Typography>
                    <Typography variant="h6">{selectedTicket.issue_title}</Typography>
                    <MDBox mt={2}>
                      <Typography variant="button">Description:</Typography>
                      <Typography>{selectedTicket.issue_description}</Typography>
                    </MDBox>
                    <MDBox mt={2}>
                      <Typography variant="button">Supporting Document:</Typography>
                    </MDBox>
                    {selectedTicket.supporting_doc_url && (
                      <img src={selectedTicket.supporting_doc_url} alt="Supporting Document" style={{ marginTop: '10px', maxWidth: '100%' }} />
                    )}
                  </MDBox><MDBox>
                      <Typography variant="overline">issued By: {selectedTicket.chat[0].created_person_name}</Typography>
                    </MDBox></>
                )}
              </DialogContent>
              <DialogActions style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MDButton
                    onClick={() => onExpandedChatClick(selectedTicket)}
                    variant="outlined"
                    color="primary"
                    startIcon={<ChatIcon style={{ color: "blue" }} />}
                    style={{
                      alignSelf: "flex-start",
                      borderColor: "blue",
                      color: "blue",
                      marginRight: "8px",
                    }}
                  >
                    Chat
                  </MDButton>
                  {!isSuperAdmin && !isSubAdmin && (
                  <MDButton
                    onClick={() => handleForward(selectedTicket.ticket_id)}
                    variant="outlined"
                    color="primary"
                    style={{
                      alignSelf: "flex-start",
                      borderColor: "blue",
                      color: "blue",
                      marginRight: "8px", 
                    }}
                  >
                    Forward
                  </MDButton>
                )}

                  <MDButton
                    onClick={() => handleDelete()}
                    variant="outlined"
                    color="error"
                  >
                    Delete
                  </MDButton>
                </div>   
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FormControl variant="outlined" style={{ minWidth: "150px", padding: "8px 16px", textAlign: "center" }}>
                    <InputLabel style={{ textAlign: 'center' }}>Status</InputLabel>
                    <Select
                      value={ticketStatus}
                      onChange={handleStatusChange}
                      label="Status"
                      style={{ textAlign: "center" }}
                      MenuProps={{ PaperProps: { style: { maxHeight: 500 } } }} 
                    >
                      {statusOptions.map((statusOption) => (
                        <MenuItem
                          key={statusOption.value}
                          value={statusOption.value}
                          style={{
                            textAlign: "center",
                            height: "40px", 
                          }}
                        >
                          {statusOption.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </DialogActions>
            </Dialog>
            <Dialog
              open={showConfirmationDialog}
              onClose={() => setShowConfirmationDialog(false)}
            >
              <DialogTitle>Confirmation</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to delete this ticket?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <MDButton onClick={() => onDeleteClick(selectedTicket.ticket_id)} 
                color="info">
                  Yes
                </MDButton>
                <MDButton onClick={() => setShowConfirmationDialog(false)} color="info">
                  No
                </MDButton>
              </DialogActions>
            </Dialog>
            <Dialog
      fullWidth
      maxWidth="md"
      open={openDialog}
      onClose={() => setOpenDialog(false)}
    >
      <DialogTitle>
        Ticket
        <IconButton
          aria-label="close"
          onClick={() => setOpenDialog(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {chatData && chatData.length > 0 ? (
          <Box>
            {chatData.map((message, index) => (
              <Box
                key={index}
                className={
                  message.created_by === user_id
                    ? classes.senderChatMessageContainer
                    : classes.receiverChatMessageContainer
                }
              >
                {message.created_by !== user_id && (
                  <Typography variant="caption" display="block">
                    {message.created_person_name || `User ${message.created_by}`}
                  </Typography>
                )}
                <Typography
                  className={
                    message.created_by === user_id
                      ? classes.senderChatMessage
                      : classes.receiverChatMessage
                  }
                  style={{
                    backgroundColor:
                      message.created_by === user_id ? "#007bff" : "#ffffff",
                    color: message.created_by === user_id ? "white" : "black",
                  }}
                >
                  {message.message}
                </Typography>
              </Box>
            ))}
          </Box>
        ) : (
          <Typography>No chat messages found.</Typography>
        )}

        <div className="tickets_chatCont_replyCont">
          <TextField
            label="Message"
            fullWidth
            multiline
            minRows={1}
            maxRows={5}
            value={chatMessage}
            onChange={(e) => setChatMessage(e.target.value)}
            variant="outlined"
            sx={{
              padding: "10px",
              marginBottom: "10px",
              ...classes.senderChatMessage,
            }}
          />
          <IconButton onClick={handleSendMessage}>
            <SendIcon />
          </IconButton>
        </div>
      </DialogContent>
    </Dialog>
  </DashboardLayout>
);
}

export default Tickets;